import { Components } from '../../../styles';
import * as tokens from '@utmost.co/utmost-design-tokens';
import { tokenToPx, tokenWithOpacity } from './getToken';

export const chipTheme = {
  MuiChip: {
    styleOverrides: {
      root: {
        lineHeight: '19.5px',
        paddingInline: tokenToPx('spacingXs'),
        '.MuiChip-icon': {
          display: 'inline-flex',
          margin: 0,
          transition: 'width 0.15s ease-in-out',
          width: 0,
          overflow: 'hidden',
          '&.show-icon': {
            width: 24
          }
        },
        '.MuiChip-label': {
          transition: 'margin 0.15s ease-in-out'
        },
        '.MuiChip-icon:not(:empty) + .MuiChip-label': {
          marginLeft: -4
        },
        '.MuiChip-deleteIcon': {
          margin: 0
        }
      },
      filled: {
        color: tokens.colorOnPrimary
      },
      sizeSmall: {
        paddingInline: tokenToPx('spacingXxs'),
        '.MuiChip-icon.show-icon': {
          width: 16
        },
        '.MuiChip-icon:not(:empty) + .MuiChip-label': {
          marginLeft: -2
        }
      },
      colorDefault: {
        '&.MuiChip-outlined': {
          color: tokens.colorOnBackground,
          borderColor: tokens.colorOutline
        },
        '&.MuiChip-filled': {
          color: tokens.colorOnBackground,
          backgroundColor: tokens.colorSecondaryContainer,
          borderColor: tokens.colorSecondaryContainer,
          transition: 'filter 0.15s ease-in-out',

          '.MuiChip-deleteIconColorDefault': {
            color: tokenWithOpacity('colorOnBackground', '60%'),
            '&:hover': {
              color: `${tokens.colorOnBackground}`
            }
          },
          '&.MuiChip-clickableColorDefault:hover': {
            filter: `brightness(95%)` // @migrate tokens v5: '#b9d9f1'
          }
        }
      }
    }
  }
} satisfies Components;
